import { Post } from "./ApiBase";

export async function GenerateLinkedInSummary(options) {
  return await Post("/api/CareerStory/LinkedIn", options);
}

export async function GenerateElevatorPitch(options) {
  return await Post("/api/CareerStory/ElevatorPitch", options);
}

export async function GenerateCareerNarrative(options) {
  return await Post("/api/CareerStory/Narrative", options);
}

export async function GenerateBiography(options) {
  return await Post("/api/CareerStory/Biography", options);
}

export async function GenerateLinkedInHeadline(options) {
  return await Post("/api/CareerStory/LinkedInHeadline", options);
}

export async function GenerateLinkedInProjects() {
  return await Post("/api/CareerStory/LinkedInProjects", {});
}

export async function GenerateSuperPowers(options) {
  return await Post("/api/CareerStory/SuperPowers", options);
}

export async function OptimizeExperience(options) {
  return await Post("/api/CareerStory/OptimizeExperience", options);
}
